import { useQuery } from "@tanstack/react-query";
import { listProductOfferings } from "@/api/publicCatalog";
import {
  selectProductOfferingCtas,
  PRODUCT_OFFERING_CTA_FALLBACK as CTA_FALLBACK,
} from "@/lib/productOfferingCtas.mjs";

export type CtaProductType = "toy" | "story" | "animation";

export type ProductOfferingCta = {
  productType: CtaProductType;
  name: string;
  nameEn: string | null;
  href: string;
};

/** Default trio when fetch fails or UI is still loading. */
export const PRODUCT_OFFERING_CTA_FALLBACK: ProductOfferingCta[] = CTA_FALLBACK;

export function useProductOfferings() {
  return useQuery({
    queryKey: ["product-offerings"],
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<ProductOfferingCta[]> => {
      try {
        const rows = await listProductOfferings();
        return selectProductOfferingCtas(rows);
      } catch {
        return PRODUCT_OFFERING_CTA_FALLBACK;
      }
    },
  });
}
